import { Grid, Paper, Tooltip, Chip, Box } from '@mui/material';
import { useEffect, useState, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SCUILoading } from '../../../../atomic/atoms';
import { CustomerQuery, PaymentQuery } from '../../../../services/query';
import { useLocation } from 'react-router';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { SCUICustomDataGrid } from '../../../../atomic/molecules';
import { PaymentCommand } from '../../../../services/command';
import TimeHelper from '../../../../utils/time';
import { CGC } from './customerGiftCard.classes';

export const CustomerGiftCard: FC<any> = ({ datas }) => {
    const { t } = useTranslation();
    const [transactionDatas, setTransactionDatas] = useState<any>();
    const search = useLocation().search;
    const searchParams = new URLSearchParams(search);
    const [giftCards, setGiftCards] = useState<any>();
    const [lcwGiftCardMoney, setlcwGiftCardMoney] = useState<any>();
    const [pageSize, setPageSize] = useState(5);
    const [pageSizeTransaction, setPageSizeTransaction] = useState(5);

    const columns: ExtendedGridColDef[] = [
        {
            field: 'orderNumber',
            headerName: t('customerInformation.orderNumber'),
            flex: 1,
        },
        {
            field: 'description',
            headerName: t('customerInformation.description'),
            flex: 1,
            hide: false,
            renderCell: (params: any) => {
                return (
                    <div>
                        <Tooltip title={<h1>{params.row.description}</h1>}>
                            <p>
                                {params.row.description.length > 30
                                    ? params.row.description.slice(0, 30) + ' ...'
                                    : params.row.description}
                            </p>
                        </Tooltip>
                    </div>
                );
            },
        },
        {
            field: 'amountString',
            headerName: t('customerInformation.amountString'),
            flex: 1,
        },
        {
            field: 'dateTimeString',
            headerName: t('customerInformation.dateTimeString'),
            flex: 1,
        },

        {
            field: 'cardNumber',
            headerName: t('customerInformation.cardNumber'),
            flex: 1,
        },
    ];
    const columnsGiftCards: ExtendedGridColDef[] = [
        {
            field: 'customerGiftCardId',
            headerName: 'Customer Gift Card Id',
            flex: 1,
        },
        {
            field: 'createdDate',
            headerName: t('customerInformation.createdDate'),
            flex: 1,
        },
        {
            field: 'expirationDate',
            headerName: t('customerInformation.expirationDate'),
            flex: 1,
        },

        {
            field: 'balance',
            headerName: t('customerInformation.balance'),
            flex: 1,
        },
        {
            field: 'cardNumber',
            headerName: t('customerInformation.cardNumber'),
            flex: 1,
        },
        {
            field: 'isActive',
            headerName: t('customerInformation.cardStatu'),
            flex: 1,
            renderCell: (params: any) => {
                    return (
                        <Chip
                            className={CGC.fieldChipCardStatus}
                            label={params.row.isActive}
                            color={params.row.isActive === 'Aktif' ? 'success' : 'error'}
                        ></Chip>
                    );
            },
        },
    ];
    const getGiftCardTransactionDatas = () => {
        let customerIdValue;
        if (!datas) {
            customerIdValue = Number(searchParams.get('customerId')) || Number(searchParams.get('CustomerId'));
        } else {
            customerIdValue = datas.customer.customerId;
        }
        const requestData = { customerId: customerIdValue };
        CustomerQuery.GetGiftCardTransactionDatas(requestData)
            .then((res: any) => {
                if (res.data) {
                    let parseData = res.data.map((item: any) => {
                        return {
                            description: item.description || '-',
                            amount: item.amount || '-',
                            amountString: item.amountString || '-',
                            dateTime: item.dateTime || '-',
                            dateTimeString: item.dateTimeString,
                            orderNumber: item.orderNumber || '-',
                            cardNumber: item.cardNumber || '-',
                        };
                    });
                    setTransactionDatas(parseData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };
    const GetCardList = () => {
        let customerIdValue;
        if (!datas) {
            customerIdValue = Number(searchParams.get('customerId')) || Number(searchParams.get('CustomerId'));
        } else {
            customerIdValue = datas.customer.customerId;
        }
        const requestData = { customerId: customerIdValue };
        PaymentCommand.GetCardListByCustomerId(requestData).then((res: any) => {
            if (res.cards) {
                let parseData = res.cards.map((item: any) => {
                    return {
                        cardNumber: item.cardNumber || '-',
                        serialNumber: item.serialNumber || '-',
                        isActive: item.isActive === true ? t('general.active') : t('general.passive'),
                        balance: item.balance + ' ' + import.meta.env.VITE_CURRENCY! || '-',
                        expirationDate: TimeHelper.reverseDateFormat(item.expirationDate) || '-',
                        createdDate: TimeHelper.reverseDateFormat(item.createdDate) || '-',
                        customerGiftCardId: item.customerGiftCardId || '-',
                    };
                });
                setGiftCards(parseData);
            }
        });
    };
    const GetRefundMoneyBalance = () => {
        let customerIdValue;
        if (!datas) {
            customerIdValue = Number(searchParams.get('customerId')) || Number(searchParams.get('CustomerId'));
        } else {
            customerIdValue = datas.customer.customerId;
        }
        const requestData = {
            customerId: customerIdValue,
            regionId: JSON.parse(localStorage.getItem('selectedCountry') || '{}')?.regionId,
        };
        PaymentQuery.GetRefundMoneyBalance(requestData).then((res: any) => {
            if (res) {
                let parseData = res.lcwGiftCardMoney;
                setlcwGiftCardMoney(parseData);
            }
        });
    };

    useEffect(() => {
        getGiftCardTransactionDatas();
        GetCardList();
        GetRefundMoneyBalance();
    }, []);

    return (
        <Grid container justifyContent={'space-between'} sx={{ margin: '1rem' }} className={CGC.page}>
            <Grid
                sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                size={{
                    xl: 12,
                    lg: 12,
                    md: 12,
                    xs: 12,
                }}
            >
                <Paper sx={{ width: '100%', padding: '2rem', margin: '1rem' }} className={CGC.paperGiftCards}>
                    {giftCards ? (
                        <>
                            <Grid
                                className={CGC.titleGiftCards}
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                                size={{
                                    xl: 12,
                                    lg: 12,
                                    md: 12,
                                    xs: 12,
                                }}
                            >
                                <b>{t('customerInformation.giftCards')}</b>
                            </Grid>
                            <Grid
                                className={CGC.fieldRefundBalance}
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'left',
                                    alignItems: 'left',
                                }}
                                size={{
                                    xl: 12,
                                    lg: 12,
                                    md: 12,
                                    xs: 12,
                                }}
                            >
                                <b>
                                    {t('customerInformation.refundMoneyBalance')}: {lcwGiftCardMoney}{' '}
                                    {import.meta.env.VITE_CURRENCY}
                                </b>
                            </Grid>
                            <Grid
                                sx={{ marginRight: '1.5rem' }}
                                size={{
                                    xl: 12,
                                    lg: 12,
                                    md: 12,
                                    xs: 12,
                                }}
                            >
                                <Box className={CGC.datagridGiftCards}>
                                    <SCUICustomDataGrid
                                        rows={giftCards}
                                        columns={columnsGiftCards}
                                        randomId
                                        pageSize={pageSize}
                                        onPageSizeChange={(i: number) => {
                                            setPageSize(i);
                                        }}
                                    />
                                </Box>
                            </Grid>
                        </>
                    ) : (
                        <SCUILoading />
                    )}
                </Paper>
            </Grid>
            <Paper sx={{ width: '100%', padding: '2rem', margin: '1rem' }} className={CGC.paperTransactions}>
                <Grid
                    className={CGC.gridTransactions}
                    sx={{ marginTop: '3rem' }}
                    size={{
                        xl: 12,
                        lg: 12,
                        md: 12,
                        xs: 12,
                    }}
                >
                    {transactionDatas ? (
                        <Grid
                            sx={{ marginRight: '1.5rem' }}
                            size={{
                                xl: 12,
                                lg: 12,
                                md: 12,
                                xs: 12,
                            }}
                        >
                            <Grid
                                className={CGC.titleTransactions}
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}
                                size={{
                                    xl: 12,
                                    lg: 12,
                                    md: 12,
                                    xs: 12,
                                }}
                            >
                                <b>{t('customerInformation.giftCardTransactions')}</b>
                            </Grid>
                            <Box className={CGC.datagridTransactions}>
                                <SCUICustomDataGrid
                                    rows={transactionDatas}
                                    columns={columns}
                                    randomId
                                    pageSize={pageSizeTransaction}
                                    onPageSizeChange={(i: number) => {
                                        setPageSizeTransaction(i);
                                    }}
                                />
                            </Box>
                        </Grid>
                    ) : (
                        <SCUILoading />
                    )}
                </Grid>
            </Paper>
        </Grid>
    );
};
